var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M2.81744 14.8732V13.781C2.85873 12.97 3.34624 12.2487 4.08339 11.9081C7.5595 10.5118 11.4405 10.5118 14.9166 11.9081C15.6538 12.2487 16.1413 12.97 16.1826 13.781V14.8732C16.1823 15.4644 15.947 16.0313 15.5285 16.449C15.11 16.8667 14.5427 17.1009 13.9514 17.1H5.04859C4.45734 17.1009 3.88999 16.8667 3.47151 16.449C3.05303 16.0313 2.81773 15.4644 2.81744 14.8732ZM9.50002 1.9C7.99809 1.89956 6.64381 2.80396 6.06874 4.19143C5.49368 5.57891 5.81109 7.17617 6.87296 8.23835C7.93482 9.30053 9.532 9.61841 10.9196 9.04375C12.3073 8.46908 13.2121 7.11507 13.2121 5.61314C13.2124 4.62846 12.8214 3.684 12.1252 2.98762C11.429 2.29124 10.4847 1.9 9.50002 1.9Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame6);
export default __webpack_public_path__ + "static/media/Frame (6).928ccc2a74ce7463c96dcbc6dbbfad58.svg";
export { ForwardRef as ReactComponent };